import { render, staticRenderFns } from "./TwoParallels.vue?vue&type=template&id=12fa0db0&scoped=true&"
import script from "./TwoParallels.vue?vue&type=script&lang=js&"
export * from "./TwoParallels.vue?vue&type=script&lang=js&"
import style0 from "./TwoParallels.vue?vue&type=style&index=0&id=12fa0db0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fa0db0",
  null
  
)

export default component.exports